import { MaxWidthView } from '@flix/common/elements/layout'
import { ErrorMessage } from '@flix/common/elements/status/ErrorMessage/ErrorMessage'

const ErrorPage = ({ error, children }) => (
  <MaxWidthView>
    <ErrorMessage error={error} mt="xxlarge">
      {children}
    </ErrorMessage>
  </MaxWidthView>
)

export default ErrorPage
